module.exports = __webpack_public_path__ + "europa-20_front.jpg?7c9af4a86a1bb5fdc4d2567bbb73878e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-20_front.jpg
// module id = 332
// module chunks = 0